import { axiosGet, axiosPatch } from "../../../redux/setupAxios";

export function getUserProfile() {
  return axiosGet("/user");
}

export function EditProfile(data) {
  return axiosPatch("/admin/edit-admin", data);
}
